import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {NamedPermissionCheckType} from "./__graphql-types__/index.ts";

export const PERMISSION_QUERY: GqlOperation<
    NamedPermissionCheckType["response"],
    NamedPermissionCheckType["variables"]
> = gqlOp(gql`
    query NamedPermissionCheck($name: String!, $scope: Scope) {
        user {
            id
            hasPermission(name: $name, scope: $scope)
        }
    }
`);
